import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import s from './index.module.css';
import Button from "@UI/New/Button";

export const FormatLesson = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    return (
       <div className={s.formatLessonWrapper}>
            <Button 
                onClick={() => setFieldInState({field: 'isOffline', value: false, resetFields: ['link_to_meeting', 'link_to_meeting_for_children', 'audienceNumber']})} 
                color={state.isOffline ? "secondary" : "primary"}>ONLINE</Button>
            <Button 
                onClick={() => setFieldInState({field: 'isOffline', value: true, resetFields: ['inRecording']})}
                color={state.isOffline ? "primary" : "secondary"}>OFFLINE</Button>
       </div>
    )
}